import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { withPathParams } from '@helpcenter/with-path-params';
import type { RouteContext } from 'react-resource-router';
import type { State } from 'state';
import { getIsAnonymousEnabled } from 'state/selectors/env';
import { isLoggedIn } from 'state/selectors/user';
import { withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import { withBrowserMetricsScreenTransitionStatus } from '@atlassian/help-center-common-util/analytics/browsermetrics-screen-transition-status-context';
import { RequestFeedback } from './request-feedback';

const selector = createSelector(
    isLoggedIn,
    getIsAnonymousEnabled,
    (_: State, props: RouteContext) => props.location.search,
    (loggedIn, anonymousEnabled, locationSearch) => ({
        anonymousEnabled,
        locationSearch,
        isLoggedIn: loggedIn,
    })
);

const RequestFeedbackWithBrowserMetrics = withBrowserMetricsScreenTransitionStatus(RequestFeedback);

const RequestFeedbackWithBrowserMetricsAndAnalytics = withAnalyticsContext({
    componentName: 'RequestFeedbackComponent',
})(withAnalyticsEvents({})(RequestFeedbackWithBrowserMetrics));

export default connect(selector)(withPathParams(RequestFeedbackWithBrowserMetricsAndAnalytics));
